/* Where the API is.

   Its own module rather than a constant in http.ts, because session.ts needs
   it too and http.ts imports session.ts for the token: leaving the value in
   http.ts makes those two a cycle, and whichever of them a bundler happens to
   evaluate first would read the other's exports before they exist.

   Configuration, not a constant: the API is on localhost in development and
   on its own host in production, and neither belongs in the source. */
export const API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:4000'
